import { apiSlice } from '@/api'

export const partnersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.query({
      query: () => ({
        url: 'api/v2/partners',
        method: 'GET'
      }),
      providesTags: (result, _error, _arg) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Partners', id })), 'Partners']
          : ['Partners']
    }),
    updatePartner: builder.mutation({
      query: (body) => ({
        url: 'api/v2/partners',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Partners']
    }),
    createPartner: builder.mutation({
      query: (body) => ({
        url: 'api/v2/partners',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Partners']
    }),
    deletePartner: builder.mutation({
      query: (id) => ({
        url: `api/v2/partners/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Partners']
    })
  })
})

export const {
  useGetPartnersQuery,
  useUpdatePartnerMutation,
  useCreatePartnerMutation,
  useDeletePartnerMutation
} = partnersApiSlice
